import i18n from 'helper/i18n';
import * as React from 'react';

import Coach from 'components/atoms/Coach';

export type CoachIsEnumType = 'LEO' | 'MIA';

export type CoachProps = {
	name: string;
	id: CoachIsEnumType;
};

export type CoachSelectorProps = {
	coaches: CoachProps[];
	selectedCoach?: CoachIsEnumType;
	onCoachChange: (...args: any) => void;
};

export default class CoachSelector extends React.Component<CoachSelectorProps> {
	public static displayName = 'CoachSelector';

	public static defaultProps = {
		coaches: [],
	};

	public static stateClasses = {
		inactive: 'state-m-coach-selector__coach--inactive',
		selected: 'state-m-coach-selector__coach--selected',
	};

	public renderCoach = (coach: CoachProps) => {
		const selectedCoach = this.props.selectedCoach;
		const coachAlias = coach.id;
		const coachClasses = ['m-coach-selector__coach'];

		if (selectedCoach && coach.id && selectedCoach.toLowerCase() === coach.id.toLowerCase()) {
			coachClasses.push(CoachSelector.stateClasses.selected);
		} else if (selectedCoach !== undefined) {
			/*
			 * Only set inactive class if any coach was selected,
			 * @see https://jira.migros.net/browse/PULSWM-2122
			 */
			coachClasses.push(CoachSelector.stateClasses.inactive);
		}

		return (
			<li
				key={coach.name.toLowerCase()}
				className={coachClasses.join(' ')}
				onClick={() => {
					this.props.onCoachChange(coachAlias);
				}}
			>
				<div className="m-coach-selector__bubble">
					<div className="m-coach-selector__bg" />
					<div className="m-coach-selector__coach-box">
						<div className="m-coach-selector__coach-wrap">
							<Coach coach={coachAlias} gesture="front-good" alt={coach.name} />
						</div>
					</div>
				</div>
				<span className="m-coach-selector__name">{coach.name}</span>
				<span className="m-coach-selector__text">
					{i18n(`react.impulsCoach.components.coachSelector.${coachAlias}.text`)}
				</span>
			</li>
		);
	};

	public render() {
		const { coaches } = this.props;

		return <ol className="m-coach-selector">{coaches.map(this.renderCoach)}</ol>;
	}
}
